module.exports = __webpack_public_path__ + "08bdb32cdbb23ac76c228fcc3ce82fa3.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg29.jpeg
// module id = 38
// module chunks = 0